module.exports = __webpack_public_path__ + "static/media/yuntaishan4.e38b75db.webp";